<template>
  <el-popover
    ref="noticePopover"
    placement="top-right"
    width="260"
    trigger="click"
    @show="loadNoticeList"
    @hide="handlePopoverHide"
    :popper-append-to-body="false"
    popper-class="custom-notice-popover"
  >
    <div class="notice-popup">
      <div class="popup-header">
        <span>系统提醒</span>
        <el-button size="mini" type="text" @click="markAllRead"
          >全部已读</el-button
        >
      </div>
      <div
        class="popup-content"
        style="max-height: 300px; overflow-y: auto"
        v-if="noticeList.length > 0"
      >
        <div
          class="notice-item"
          v-for="item in noticeList"
          :key="item.id"
          :class="{ unread: !item.read }"
          @click="handleNoticeClick(item)"
        >
          <div class="notice-title">{{ item.title }}</div>
          <div class="notice-time">{{ formatTime(item.createTime) }}</div>
        </div>
      </div>
      <div class="empty-tip" v-else>暂无未读提醒</div>
    </div>

    <div slot="reference" class="notice-trigger">
      <i class="el-icon-bell"></i>
      <!-- 仅在未读数量有效时显示角标 -->
      <sup class="badge" v-show="isValidUnreadCount">{{
        formatUnreadCount(unreadCount)
      }}</sup>
    </div>
  </el-popover>
</template>

<script>
import {
  getNoticeList,
  getUnreadCount,
  markNoticeRead,
  markAllNoticeRead,
} from "@/api/notice/noticeApi";
import { getUserId } from "@/api/user/userApi";

export default {
  name: "NoticePopup",
  data() {
    return {
      noticeList: [],
      unreadCount: 0,
      timer: null,
      userId: "",
      targetId: "",
      noticeTypeMap: {
        1: "房屋费用到期提醒",
        2: "合同到期提醒",
        3: "员工操作提醒",
      },
    };
  },
  computed: {
    // 校验未读数量是否为有效数字且大于0
    isValidUnreadCount() {
      return typeof this.unreadCount === "number" && this.unreadCount > 0;
    },
  },
  async mounted() {
    await this.initUserInfo();
    if (this.targetId) {
      await this.getUnreadCount();
      // 5分钟定时刷新未读数量
      this.timer = setInterval(() => this.getUnreadCount(), 3000000);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    async initUserInfo() {
      try {
        const userIdRes = await getUserId();
        this.userId = userIdRes || "";
        this.targetId = this.userId;
      } catch (err) {
        console.error("初始化用户信息失败：", err);
        this.$message.warning("用户信息加载失败，提醒功能暂不可用");
      }
    },
    async getUnreadCount() {
      if (!this.targetId) {
        console.warn("未获取到有效用户信息，跳过未读数查询");
        this.unreadCount = 0;
        return;
      }
      try {
        const params = { targetId: this.targetId };
        const res = await getUnreadCount(params);
        console.log(res, "res!!!!!!!!!!!");
        // 校验接口返回数据并转换为有效数字
        const rawCount = res.data;
        console.log(rawCount, "rawCount");
        this.unreadCount = isNaN(Number(rawCount)) ? 0 : Number(rawCount);
        console.log("当前未读数量（已校验）：", this.unreadCount);
      } catch (err) {
        console.error("获取未读提醒数失败：", err);
        this.unreadCount = 0; // 异常时兜底为0
        if (!err.message.includes("Network Error")) {
          this.$message.error("获取未读提醒数失败，请稍后重试");
        }
      }
    },
    async loadNoticeList() {
      if (!this.targetId) {
        console.warn("未获取到有效用户信息，跳过提醒列表查询");
        return;
      }
      try {
        const params = { targetId: this.targetId, readStatus: 0 };
        const res = await getNoticeList(params);
        if (!res.data || !Array.isArray(res.data)) {
          this.noticeList = [];
          this.unreadCount = 0;
          return;
        }
        this.noticeList = res.data
          .filter((item) => item.id)
          .map((item) => ({
            ...item,
            title:
              item.title || this.noticeTypeMap[item.noticeType] || "系统提醒",
            content:
              item.content ||
              `${this.noticeTypeMap[item.noticeType] || "系统提醒"} - 关联ID：${
                item.relatedId || "无"
              }`,
            createTime: item.createTime || Date.now(),
            read: item.readStatus === 1,
            jumpUrl: item.jumpUrl || `/#/notice/detail/${item.id}`,
          }));
        // 同步未读数量（确保为有效数字）
        this.unreadCount = isNaN(this.noticeList.length)
          ? 0
          : this.noticeList.length;
      } catch (err) {
        console.error("加载提醒列表失败：", err);
        this.$message.error("加载提醒列表失败，请稍后重试");
        this.noticeList = [];
        this.unreadCount = 0;
      }
    },
    async handleNoticeClick(item) {
      if (item.read) {
        this.jumpToTargetPage(item);
        return;
      }
      try {
        const params = { id: item.id };
        await markNoticeRead(params);
        item.read = true;
        // 减少未读数量时确保为有效数字
        this.unreadCount = Math.max(
          isNaN(this.unreadCount) ? 0 : this.unreadCount - 1,
          0
        );
        this.jumpToTargetPage(item);
        this.$message.success("标记已读成功");
      } catch (err) {
        console.error("标记已读失败：", err);
        this.$message.error("标记已读失败，请稍后重试");
      }
    },
    async markAllRead() {
      if (!this.targetId) {
        this.$message.warning("用户信息异常，操作失败");
        return;
      }
      try {
        const params = { targetId: this.targetId };
        await markAllNoticeRead(params);
        this.noticeList.forEach((item) => (item.read = true));
        this.unreadCount = 0;
        this.$message.success("已标记全部提醒为已读");
      } catch (err) {
        console.error("标记全部已读失败：", err);
        this.$message.error("标记全部已读失败，请稍后重试");
      }
    },
    jumpToTargetPage(item) {
      if (!item.jumpUrl) return;
      try {
        item.jumpUrl.startsWith("http")
          ? window.open(item.jumpUrl, "_blank")
          : this.$router.push(item.jumpUrl).catch((err) => {
              if (err.name !== "NavigationDuplicated") throw err;
            });
      } catch (err) {
        console.error("跳转页面失败：", err);
        this.$message.warning("跳转页面失败，请手动操作");
      }
    },
    formatTime(time) {
      if (!time) return "未知时间";
      try {
        let timestamp = typeof time === "string" ? Number(time) : time;
        if (timestamp.toString().length === 10) timestamp *= 1000;
        return new Date(timestamp).toLocaleString("zh-CN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        });
      } catch (err) {
        console.error("格式化时间失败：", err);
        return "未知时间";
      }
    },
    formatUnreadCount(count) {
      // 格式化时兜底处理非数字情况
      if (isNaN(count) || typeof count !== "number") return 0;
      return count > 99 ? "99+" : count;
    },
    handlePopoverHide() {
      setTimeout(() => this.getUnreadCount(), 1000);
    },
  },
};
</script>

<style scoped>
.custom-notice-popover {
  max-width: 90vw !important;
  max-height: 80vh !important;
  overflow: hidden !important;
}

.notice-trigger {
  position: relative;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  margin-right: 20px;
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  z-index: 10;
}

.notice-trigger:hover {
  color: #e6f7ff;
}

.badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #f56c6c;
  color: #fff;
  font-size: 12px;
  padding: 0 5px;
  border-radius: 10px;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  animation: badgeFlash 1s infinite alternate;
  z-index: 11;
  box-shadow: 0 0 3px rgba(245, 108, 108, 0.8);
  display: inline-block !important;
}

@keyframes badgeFlash {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.8;
  }
}

.notice-popup {
  padding: 10px 0;
  box-sizing: border-box;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px 10px;
  border-bottom: 1px solid #e6e6e6;
}

.popup-content ::-webkit-scrollbar {
  width: 4px;
}
.popup-content ::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 2px;
}

.notice-item {
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  transition: background-color 0.2s;
  box-sizing: border-box;
}

.notice-item.unread {
  background-color: #fef0f0;
  border-left: 3px solid #f56c6c;
}

.notice-item:hover {
  background-color: #f5f7fa;
}

.notice-title {
  font-weight: 600;
  margin-bottom: 5px;
  font-size: 14px;
  word-wrap: break-word;
}

.notice-time {
  font-size: 12px;
  color: #999;
  margin-bottom: 5px;
}

.empty-tip {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 14px;
}
</style>
